import { yandexMap, ymapMarker } from 'vue-yandex-maps';
export default {
  name: 'ContactsPage',
  components: {
    yandexMap,
    ymapMarker
  }
};